import { Controller } from "@hotwired/stimulus"
import $ from 'jquery';
import {MDCChip} from '@material/chips';

export default class extends Controller {
  static targets = [ "interests" ]


  connect() {
    let _this = this;
    const chipElements = this.element.querySelectorAll('.categories .mdc-chip');
  
    chipElements.forEach((chipEl) => {   
      const chip = new MDCChip(chipEl);   
      chip.listen('MDCChip:interaction', () => {

        if (($("#form_categories").children().length < 5) || chip.selected) {
          console.log($("#form_categories").children().length);
          chip.selected = !chip.selected;
          setTimeout(function () {_this.setCategory($(chipEl).data("category"));}, 200);
        }
      });  
    });
  }

  setInterest(event) {

    $("#form_interests").empty();

    $(".interests .mdc-ripple-upgraded--foreground-activation:not(.mdc-chip--selected), .interests .mdc-chip--selected:not(.mdc-ripple-upgraded--foreground-activation)").each(function( index ) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "service_request[interest][]";
      input.value = $( this ).data("interest");

      $("#form_interests").append(input);
    });

  }

  setTheme(event) {

    $("#form_themes").empty();

    $(".themes .mdc-ripple-upgraded--foreground-activation:not(.mdc-chip--selected), .themes .mdc-chip--selected:not(.mdc-ripple-upgraded--foreground-activation)").each(function( index ) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "service_request[theme][]";
      input.value = $( this ).data("theme");

      $("#form_themes").append(input);
    });

  }


  setCategory(category) {

    $("#form_categories").empty();

    $(".categories .mdc-ripple-upgraded--foreground-activation:not(.mdc-chip--selected), .categories .mdc-chip--selected:not(.mdc-ripple-upgraded--foreground-activation)").each(function( index ) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "service_request[categories][]";
      input.value =  $( this ).data("category");

      $("#form_categories").append(input);
    });

  }


}
